module.exports = __webpack_public_path__ + "img/hero_image.fe2f4f9d.jpeg";